import { z } from "zod";

/** Same slug shape as stores (docs/database-schema.md §6.1). */
export const categorySlugSchema = z
  .string()
  .trim()
  .toLowerCase()
  .min(1)
  .max(160)
  .regex(
    /^[a-z0-9]+(-[a-z0-9]+)*$/,
    "Slug must contain only lowercase letters, numbers, and hyphens.",
  );

export const categoryCodeSchema = z
  .string()
  .trim()
  .toUpperCase()
  .min(1)
  .max(100)
  .regex(/^[A-Z0-9_]+$/, "Code must contain only uppercase letters, numbers, and underscores.");

export const createCategorySchema = z.object({
  parentId: z.string().uuid().optional(),
  code: categoryCodeSchema,
  nameTh: z.string().trim().min(1).max(200),
  nameEn: z.string().trim().max(200).optional(),
  slug: categorySlugSchema,
  iconUrl: z.string().trim().url().optional(),
  sortOrder: z.number().int().min(0).optional(),
});
export type CreateCategoryInput = z.infer<typeof createCategorySchema>;

export const updateCategorySchema = z.object({
  parentId: z.string().uuid().optional(),
  nameTh: z.string().trim().min(1).max(200).optional(),
  nameEn: z.string().trim().max(200).optional(),
  slug: categorySlugSchema.optional(),
  iconUrl: z.string().trim().url().optional(),
  sortOrder: z.number().int().min(0).optional(),
});
export type UpdateCategoryInput = z.infer<typeof updateCategorySchema>;
